import React from "react";
import {
  Box,
  Typography,
  Container,
  Link,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import guardImage2 from "../assets/guardsee.jpg";

function Contact() {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          backgroundImage: `url(${guardImage2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          textAlign: "center",
          color: "#fff",
          py: { xs: 7, md: 12 },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "rgba(0,0,0,0.55)",
          }}
        />

        <Box sx={{ position: "relative", zIndex: 1, px: 2 }}>
          <Typography
            sx={{
              fontWeight: "bold",
              textTransform: "uppercase",
              fontSize: { xs: "26px", md: "40px" },
            }}
          >
            Contact Us
          </Typography>

          <Typography
            sx={{
              mt: 2,
              fontSize: { xs: "14px", md: "18px" },
              maxWidth: 700,
              mx: "auto",
            }}
          >
            Have a question or need professional security services? Reach out to
            us and our team will respond promptly.
          </Typography>
        </Box>
      </Box>

      {/* Contact Cards */}
      <Container sx={{ py: { xs: 6, md: 10 } }}>
        <Grid container spacing={4} justifyContent="center" alignItems="stretch">
          {/* Email */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper sx={cardStyle}>
              <EmailIcon sx={iconStyle} />
              <Typography sx={titleStyle}>Email</Typography>
              <Link href="mailto:info@lineguardsecurity.ca" sx={linkStyle}>
                info@lineguardsecurity.ca
              </Link>
            </Paper>
          </Grid>

          {/* Phone */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper sx={cardStyle}>
              <PhoneIcon sx={iconStyle} />
              <Typography sx={titleStyle}>Call Us</Typography>
              <Link href="tel:+12362382587" sx={linkStyle}>
                +1-236-238-2587
              </Link>
            </Paper>
          </Grid>

          {/* Location */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper sx={cardStyle}>
              <LocationOnIcon sx={iconStyle} />
              <Typography sx={titleStyle}>Location</Typography>
              <Typography>Vancouver Island, BC</Typography>
            </Paper>
          </Grid>

          {/* Social */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper sx={cardStyle}>
              {/* Invisible icon space to match height */}
              <Box sx={{ height: 46, mb: 2 }} />

              <Typography sx={{ ...titleStyle, mb: 2 }}>
                Connect With Us
              </Typography>

              <Box sx={{ display: "flex", justifyContent: "center", gap: 3 }}>
                <Link
                  href="https://www.facebook.com/profile.php?id=61581235222116"
                  target="_blank"
                  sx={{ color: "#4267B2" }}
                >
                  <FacebookIcon sx={{ fontSize: 36 }} />
                </Link>

                <Box sx={{ color: "#E1306C" }}>
                  <InstagramIcon sx={{ fontSize: 36 }} />
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

/* Shared Styles */
const cardStyle = {
  p: 4,
  textAlign: "center",
  borderRadius: 3,
  boxShadow: 3,
  height: { xs: 240, md: 260 }, // fixed height for all cards
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

const iconStyle = {
  fontSize: 46,
  color: "#002147",
  mb: 2,
};

const titleStyle = {
  fontWeight: "bold",
  mb: 1,
};

const linkStyle = {
  color: "#002147",
  fontWeight: 500,
};

export default Contact;
